import React from 'react';
import Modal from '../common/Modal.jsx';
import FormularioParteDiario from './FormularioParteDiario.jsx';

const ModalParteDiario = ({ isOpen, onClose, onSaved, parteDiario = null, initialEquipo = null }) => {
  const handleSave = async (savedData, opts = {}) => {
    if (typeof onSaved === 'function') {
      await onSaved();
    }
    if (opts.keepOpen) return; // "Guardar y nuevo/duplicar": el modal se queda abierto
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleCancel = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title={parteDiario ? 'Editar Parte Diario' : 'Nuevo Parte Diario'}
      size="lg"
    >
      <FormularioParteDiario
        parteDiario={parteDiario || undefined}
        initialEquipo={parteDiario ? undefined : initialEquipo}
        onSave={handleSave}
        onCancel={handleCancel}
        showTitle={false}
        compact
        enableSaveAndNew={!parteDiario}
      />
    </Modal>
  );
};

export default ModalParteDiario;
